export const GetCardBorderColor = (typeOfCard) => {
  switch (typeOfCard) {
    case 'Truth':
      return 'rgba(180, 60, 160, 0.5)';
    case 'Light Dare':
      return 'rgba(210, 55, 90, 0.5)';
    case 'Dare':
      return 'rgba(210, 60, 30, 0.5)';
    case 'Kinky Dare':
      return 'rgba(220, 20, 20, 0.55)';
    default:
      return 'rgba(180, 60, 160, 0.5)';
  }
};
